export function hideSummary(summary, items) {
    if (items.visible) {
        $(summary).css('opacity', 0)
    }
}